export default __webpack_public_path__ + "static/media/fleetbg.4c691cd3.png";